import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { LoginService } from 'src/app/core/login/login.service';

@Component({
  selector: 'wsb-confirm-changes',
  templateUrl: './confirm-changes.component.html',
  styleUrls: ['./confirm-changes.component.scss'],
  standalone: false
})
export class ConfirmChangesComponent {
  @Input() label = '';
  @Input() title = '';
  checkPassword: UntypedFormControl = new UntypedFormControl('', []);

  constructor(public activeModal: NgbActiveModal, private loginService: LoginService, private atlasToast: AtlasToastService) {}

  checkPwd() {
    this.loginService.checkPassword(this.checkPassword.value).subscribe(
      success => {
        this.activeModal.close(true);
      },
      error => {
        this.atlasToast.error('common_error', null);
      }
    );
  }
}
